import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useBannersStore } from 'src/store/banners/banners.store';

export default function useBanners() {
  const TABLEHEADER = [{ id: 'name', label: 'Nome' }];

  const navigate = useNavigate()

  const { getBannersList, isLoadingBannersList, bannersList } = useBannersStore();

  useEffect(() => {
    getBannersList();
  }, []);

  return {
    TABLEHEADER,
    isLoadingBannersList,
    bannersList,
    navigate
  };
}
